"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MasterController = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const get_entity_utils_1 = require("../../../../service-lib/src/lib/utils/get-entity.utils");
const master_service_1 = require("./master.service");
const response_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/response.utils");
const look_up_query_param_dto_1 = require("../look-up/dto/look-up-query-param.dto");
const master_swagger_1 = require("./master.swagger");
let MasterController = class MasterController {
    constructor(masterService) {
        this.masterService = masterService;
    }
    /**
     * Retrieves all records for the specified entity, by delegating the service
     */
    async getAllRecords(entity, res, query) {
        try {
            const requestStartTime = Date.now();
            const serviceStartTime = Date.now(); // Record the service execution start time
            const records = await this.masterService.getAllRecords(entity, query?.search, query?.searchId, query?.searchBy, query?.sortBy, query?.sortOrder, query?.page, query?.limit);
            const serviceEndTime = Date.now(); // Record the service execution end time
            console.log(`Service Execution Time: ${serviceEndTime - serviceStartTime}ms`);
            const responseTime = Date.now(); // Record the response time
            console.log(`Response Time: ${responseTime - requestStartTime}ms`);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, "Records retrieved successfully", records));
        }
        catch (error) {
            return res
                .status(common_1.HttpStatus.INTERNAL_SERVER_ERROR)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error instanceof Error
                ? error.message
                : "Failed to retrieve records"));
        }
    }
    /**
     * Retrieves a single record by ID for the specified entity, by delegating the service
     */
    async getRecordById(entity, id, res) {
        try {
            const requestStartTime = Date.now();
            console.log("Request Headers: * getRecordById Master *");
            const serviceStartTime = Date.now(); // Record the service execution start time
            const entityClass = (0, get_entity_utils_1.getEntityByName)(entity);
            const record = await this.masterService.getRecordById(entityClass, id);
            const serviceEndTime = Date.now(); // Record the service execution end time
            console.log(`Service Execution Time: * getRecordById Master * ${serviceEndTime - serviceStartTime}ms`);
            const responseTime = Date.now(); // Record the response time
            console.log(`Response Time: * getRecordById Master * ${responseTime - requestStartTime}ms`);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, "Record retrieved successfully", record));
        }
        catch (error) {
            return res
                .status(common_1.HttpStatus.INTERNAL_SERVER_ERROR)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error instanceof Error ? error.message : "Failed to retrieve record"));
        }
    }
    /**
     * Creates a new record for the specified entity, by delegating the service
     */
    async createRecord(entity, data, res) {
        try {
            const requestStartTime = Date.now();
            console.log("Request Headers: * createRecord Master *");
            const serviceStartTime = Date.now(); // Record the service execution start time
            const entityClass = (0, get_entity_utils_1.getEntityByName)(entity);
            const newRecord = await this.masterService.createRecord(entityClass, data);
            const serviceEndTime = Date.now(); // Record the service execution end time
            console.log(`Service Execution Time: * createRecord Master * ${serviceEndTime - serviceStartTime}ms`);
            const responseTime = Date.now(); // Record the response time
            console.log(`Response Time: * createRecord Master * ${responseTime - requestStartTime}ms`);
            return res
                .status(common_1.HttpStatus.CREATED)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.CREATED, "Record created successfully", newRecord));
        }
        catch (error) {
            return res
                .status(common_1.HttpStatus.INTERNAL_SERVER_ERROR)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error instanceof Error ? error.message : "Failed to create record"));
        }
    }
    /**
     * Updates an existing record by ID for the specified entity, by delegating the service
     */
    async updateRecordById(entity, id, data, res) {
        try {
            const requestStartTime = Date.now();
            console.log("Request Headers: * updateRecordById Master * ");
            const serviceStartTime = Date.now(); // Record the service execution start time
            const entityClass = (0, get_entity_utils_1.getEntityByName)(entity);
            const updatedRecord = await this.masterService.updateRecordById(entityClass, id, data);
            const serviceEndTime = Date.now(); // Record the service execution end time
            console.log(`Service Execution Time: * updateRecordById Master * ${serviceEndTime - serviceStartTime}ms`);
            const responseTime = Date.now(); // Record the response time
            console.log(`Response Time: * updateRecordById Master * ${responseTime - requestStartTime}ms`);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, "Record updated successfully", updatedRecord));
        }
        catch (error) {
            return res
                .status(common_1.HttpStatus.INTERNAL_SERVER_ERROR)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error instanceof Error ? error.message : "Failed to update record"));
        }
    }
    /**
     * Deletes a record by ID for the specified entity, by delegating the service
     */
    async deleteRecordById(entity, id, res) {
        try {
            const requestStartTime = Date.now();
            console.log("Request Headers: * deleteRecordById Master *");
            const serviceStartTime = Date.now(); // Record the service execution start time
            const entityClass = (0, get_entity_utils_1.getEntityByName)(entity);
            await this.masterService.deleteRecordById(entityClass, id);
            const serviceEndTime = Date.now(); // Record the service execution end time
            console.log(`Service Execution Time: * deleteRecordById Master * ${serviceEndTime - serviceStartTime}ms`);
            const responseTime = Date.now(); // Record the response time
            console.log(`Response Time: * deleteRecordById Master * ${responseTime - requestStartTime}ms`);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, "Record deleted successfully"));
        }
        catch (error) {
            return res
                .status(common_1.HttpStatus.INTERNAL_SERVER_ERROR)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error instanceof Error ? error.message : "Failed to delete record"));
        }
    }
};
exports.MasterController = MasterController;
tslib_1.__decorate([
    (0, common_1.Get)(":entity"),
    (0, master_swagger_1.getAllRecordsSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("entity")),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__param(2, (0, common_1.Query)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, Object, typeof (_b = typeof look_up_query_param_dto_1.GetLookUpsQueryDto !== "undefined" && look_up_query_param_dto_1.GetLookUpsQueryDto) === "function" ? _b : Object]),
    tslib_1.__metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
], MasterController.prototype, "getAllRecords", null);
tslib_1.__decorate([
    (0, common_1.Get)(":entity/:id"),
    (0, master_swagger_1.getRecordByIdSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("entity")),
    tslib_1.__param(1, (0, common_1.Param)("id")),
    tslib_1.__param(2, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, String, Object]),
    tslib_1.__metadata("design:returntype", typeof (_d = typeof Promise !== "undefined" && Promise) === "function" ? _d : Object)
], MasterController.prototype, "getRecordById", null);
tslib_1.__decorate([
    (0, common_1.Post)(":entity"),
    (0, master_swagger_1.createRecordSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("entity")),
    tslib_1.__param(1, (0, common_1.Body)()),
    tslib_1.__param(2, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, typeof (_e = typeof T !== "undefined" && T) === "function" ? _e : Object, Object]),
    tslib_1.__metadata("design:returntype", typeof (_f = typeof Promise !== "undefined" && Promise) === "function" ? _f : Object)
], MasterController.prototype, "createRecord", null);
tslib_1.__decorate([
    (0, common_1.Put)(":entity/:id"),
    (0, master_swagger_1.updateRecordByIdSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("entity")),
    tslib_1.__param(1, (0, common_1.Param)("id")),
    tslib_1.__param(2, (0, common_1.Body)()),
    tslib_1.__param(3, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, String, typeof (_g = typeof T !== "undefined" && T) === "function" ? _g : Object, Object]),
    tslib_1.__metadata("design:returntype", typeof (_h = typeof Promise !== "undefined" && Promise) === "function" ? _h : Object)
], MasterController.prototype, "updateRecordById", null);
tslib_1.__decorate([
    (0, common_1.Delete)(":entity/:id"),
    (0, master_swagger_1.deleteRecordByIdSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("entity")),
    tslib_1.__param(1, (0, common_1.Param)("id")),
    tslib_1.__param(2, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [String, String, Object]),
    tslib_1.__metadata("design:returntype", typeof (_j = typeof Promise !== "undefined" && Promise) === "function" ? _j : Object)
], MasterController.prototype, "deleteRecordById", null);
exports.MasterController = MasterController = tslib_1.__decorate([
    (0, common_1.Controller)("master"),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof master_service_1.MasterService !== "undefined" && master_service_1.MasterService) === "function" ? _a : Object])
], MasterController);
